define('modules/editor/views/property_boxes/geometry',['require','exports','module','./base','ldsh!../../templates/property_boxes/geometry'],function(require, exports, module) {
  "use strict";

  var BasePropertyBox = require("./base");

  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/geometry"),
    _filterValues: function(e){
      //don't allow anything but numbers
      var value = String.fromCharCode(e.keyCode);
      //allow backspace, delete, tab, shift.tab
      var allowed = [8, 46, 9];
      if(_.contains(allowed, e.keyCode)){
        return;
      }
      if(!/^\d+$/.test(value)){
        e.preventDefault();
      }
    }
  });

});

